import {useState} from 'react'
import {PageTitle, useSelectDeviceId} from '../../../_metronic/layout/core'
import {setupstepmotor} from '../../modules/auth/core/_requests'
import {AxiosError} from 'axios'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {UnsuccessfulNotify} from '../../../ToastMetods'
import {UsersListLoading} from '../../modules/apps/user-management/users-list/components/loading/UsersListLoading'

type dataType = {
  DeviceId: number
  ExperimentId: number
  StartValue: number
  FinishValue: number
  ReadMore: boolean
  MotorId: number
}

function StepStepMotor() {
  const [experimentId, setExperimentId] = useState<number | null>(null)
  const [motorId, setMotorId] = useState<number | null>(null)
  const [pasitionId, setPasitionId] = useState<number | null>(null)
  const [value, setValue] = useState<number | null>(null)
  const [data, setData] = useState<dataType | any>([])
  const [loading, setLoading] = useState<boolean>(false)

  const {SelectDeviceId} = useSelectDeviceId()

  const handleReadValue = async (readMore: boolean) => {
    if (SelectDeviceId.length > 0) {
      setLoading(true)
      if (readMore) {
        try {
          const {data} = await setupstepmotor(
            SelectDeviceId[0],
            experimentId || 0,
            pasitionId || 0,
            value || 0,
            readMore,
            motorId || 0
          )
          setData(data)
          setValue(data.value)
        } catch (err) {
          const error = `${(err as AxiosError)?.response?.data}`
          console.error(error)
        } finally {
          setLoading(false)
        }
      } else {
        try {
          const {data} = await setupstepmotor(
            SelectDeviceId[0],
            experimentId || 0,
            pasitionId || 0,
            value || 0,
            readMore,
            motorId || 0
          )
        } catch (err) {
          const error = `${(err as AxiosError)?.response?.data}`
          console.error(error)
        } finally {
          setLoading(false)
        }
      }
    } else {
      UnsuccessfulNotify('Lütfen Cihaz Seçiniz.')
    }
  }

  if (loading) {
    return <UsersListLoading />
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{`Setup Step Motor`}</PageTitle>
      <div className='row g-5 gx-xl-10 mt-lg-n16 mt-2'>
        <div className='card card-custom col-xxl-6 p-10'>
          {/* 👇  Deney Id 👇 */}
          <div className='input-group mb-3'>
            <span className='input-group-text' id='basic-deneyId'>
              Deney Id&nbsp;
            </span>
            <input
              type='number'
              className='form-control'
              placeholder='Deney Id'
              aria-label='deneyId'
              aria-describedby='basic-deneyId'
              onChange={(e) => setExperimentId(Number(e.target.value))}
              value={experimentId ? experimentId : ''}
            />
          </div>
          {/* 👇  Motor Id 👇 */}
          <div className='input-group mb-3'>
            <span className='input-group-text' id='basic-motorId'>
              Motor Id &nbsp;
            </span>
            <input
              type='number'
              className='form-control'
              placeholder='Motor Id'
              aria-label='motorId'
              aria-describedby='basic-motorId'
              onChange={(e) => setMotorId(Number(e.target.value))}
              value={motorId ? motorId : ''}
            />
          </div>
          {/* 👇  Konum Id 👇 */}
          <div className='input-group mb-3'>
            <span className='input-group-text' id='basic-motorId'>
              Konum Id
            </span>
            <input
              type='number'
              className='form-control'
              placeholder='Konum Id'
              aria-label='pasitionId'
              aria-describedby='basic-pasitionId'
              onChange={(e) => setPasitionId(Number(e.target.value))}
              value={pasitionId ? pasitionId : ''}
            />
          </div>
          {/* 👇 Başlangıç ve Bitiş İşlemleri  👇 */}
          <div>
            <div className='col'>
              {/* 👇 Değer Oku  👇 */}
              <div className='input-group mb-3'>
                <input
                  type='text'
                  disabled
                  className='form-control'
                  value={data ? data.value : ''}
                />
                <button className='btn btn-dark' onClick={() => handleReadValue(true)}>
                  Değer Oku
                </button>
              </div>
              {/* 👇 Değer Yaz  👇 */}
              <div className='input-group mb-3'>
                <input
                  type='number'
                  className='form-control'
                  placeholder='Değer'
                  onChange={(e) => setValue(Number(e.target.value))}
                  value={value ? value : ''}
                />

                <button className='btn btn-dark' onClick={() => handleReadValue(false)}>
                  Değer Yaz
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className='card card-custom p-5 col-xxl-6 justify-content-center align-items-center'>
          <img
            className='mx-auto w-75'
            src={toAbsoluteUrl('/media/illustrations/misc/stepmotor.svg')}
          />
        </div>
      </div>
    </>
  )
}

export default StepStepMotor
